


























import {Component, Prop, Vue} from 'vue-property-decorator';
import {Action} from 'vuex-class';
import DownloadIcon from '@/assets/icons/icn-download.svg';
import AppleStoreIcon from '@/assets/icons/ios.svg';
import GooglePlayIcon from '@/assets/icons/google-play.svg';
import {SoftwareItem} from '@/types';
import {getValidToken} from '@/components/auth/token';

@Component({
  components: {
    DownloadIcon,
    AppleStoreIcon,
    GooglePlayIcon,
  },
})
export default class SoftwareDownloadButtons extends Vue {
  @Prop({required: true}) public software: SoftwareItem;
  @Action public activateSoftware: void;

  public async downloadProduct(downloadUrl?: string) {
    if (downloadUrl == null) {
      return;
    }

    let url = new URL(downloadUrl);
    if (downloadUrl.includes('{token}')) {
      const token = await getValidToken();
      if (token) {
        url = new URL(downloadUrl.replace('{token}', token));
      }
    }
    window.open(url.toString(), '_blank');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SoftwareDownloadButtons/SoftwareDownloadButtons.vue